export default {"src":"/_next/static/media/logo.1a1497cd.svg","height":170,"width":450};